import React from 'react';
import { Dialog, DialogContent, DialogActions, Button, Box, Typography } from '@mui/material';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import { PARTNER_BRAND } from '../../partnerDashboardTheme';

const ApproveMembershipRequestDialog = ({
  open,
  applicantName,
  approving = false,
  onClose,
  onConfirm,
}) => (
  <Dialog
    open={open}
    onClose={approving ? undefined : onClose}
    PaperProps={{
      sx: {
        borderRadius: 2,
        p: 2,
        textAlign: 'center',
        maxWidth: 400,
        width: '100%',
      },
    }}
  >
    <DialogContent sx={{ pb: 1, pt: 1 }}>
      <Box
        sx={{
          width: 60,
          height: 60,
          borderRadius: '50%',
          bgcolor: '#ecfdf3',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mx: 'auto',
          mb: 2,
        }}
      >
        <CheckOutlinedIcon sx={{ fontSize: 32, color: '#16a34a' }} />
      </Box>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
        Approve Membership Request?
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
        Approve{' '}
        <Box component="span" sx={{ fontWeight: 600, color: 'text.primary' }}>
          {applicantName || 'this applicant'}
        </Box>
        ? They will be added to the community and notified of your decision.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ justifyContent: 'center', gap: 2, pb: 1, pt: 2 }}>
      <Button
        variant="outlined"
        disabled={approving}
        onClick={onClose}
        sx={{
          minWidth: 120,
          height: 44,
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 1.5,
          color: PARTNER_BRAND,
          borderColor: PARTNER_BRAND,
          '&:hover': {
            borderColor: 'primary.dark',
            bgcolor: 'rgba(224, 104, 10, 0.04)',
          },
        }}
      >
        Cancel
      </Button>
      <Button
        variant="contained"
        disabled={approving}
        onClick={onConfirm}
        sx={{
          minWidth: 120,
          height: 44,
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 1.5,
          bgcolor: PARTNER_BRAND,
          boxShadow: 'none',
          '&:hover': {
            bgcolor: 'primary.dark',
            boxShadow: 'none',
          },
        }}
      >
        {approving ? 'Approving…' : 'Approve'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ApproveMembershipRequestDialog;
